import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { getJourney, uploadPhoto, agePhoto, fileUrl } from "./api";
import { loadState, updateState } from "./storage";

export const YEAR_OPTIONS = [10, 25, 40];

export const useFutureSelf = (journeyId) => {
  const [journey, setJourney] = useState(null);
  const [years, setYearsState] = useState(loadState().futureYears || 25);
  const [uploading, setUploading] = useState(false);
  const [aging, setAging] = useState(false);
  const [agingError, setAgingError] = useState(false);
  const inFlight = useRef(null);

  const refresh = useCallback(async () => {
    const j = await getJourney(journeyId);
    setJourney(j);
    return j;
  }, [journeyId]);

  useEffect(() => { refresh().catch(() => {}); }, [refresh]);

  const setYears = (y) => {
    setYearsState(y);
    updateState({ futureYears: y });
  };

  const upload = async (file) => {
    setUploading(true);
    try {
      await uploadPhoto(journeyId, file);
      await refresh();
      toast.success("Photo added. Future You will age it when you talk.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  const ensureAged = useCallback(async () => {
    if (!journey?.photo_path || journey?.aged_photos?.[years] || inFlight.current === years) return;
    inFlight.current = years;
    setAging(true);
    try {
      await agePhoto(journeyId, years);
      await refresh();
    } catch (e) {
      setAgingError(true);
      toast.error(e?.response?.data?.detail || "Couldn't age your photo.");
    } finally {
      inFlight.current = null;
      setAging(false);
    }
  }, [journey, years, journeyId, refresh]);

  const age = journey?.character?.age;
  return {
    journey,
    refresh,
    agingError,
    years,
    setYears,
    upload,
    uploading,
    aging,
    ensureAged,
    photoUrl: fileUrl(journey?.photo_path),
    agedUrl: fileUrl(journey?.aged_photos?.[years]),
    futureAgeLabel: (y = years) => (age ? `Age ${age + y}` : `+${y} yrs`),
  };
};
